var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    stroke: "#112348"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.7149C9 22.7149 11.2573 24.2857 13.1311 24.2857C15.005 24.2857 18.0895 21.1441 21.174 21.1441C24.2585 21.1441 27.454 24.2857 29.5473 24.2857C31.6406 24.2857 34.2837 21.1441 37.5902 21.1441C40.8966 21.1441 43.2623 24.2857 45.686 24.2857C47.0051 24.2857 48.1929 23.4631 49.0025 22.7149V19.5708C48.1929 20.3191 47.0051 21.1417 45.686 21.1417C43.2623 21.1417 40.8941 18 37.5902 18C34.2863 18 31.6406 21.1417 29.5473 21.1417C27.454 21.1417 24.256 18 21.1715 18C18.087 18 15.0025 21.1417 13.1286 21.1417C11.2547 21.1417 9 19.5708 9 19.5708V22.7125V22.7149Z",
    fill: "#D69B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 30.4645C9 30.4645 11.2573 32.036 13.1311 32.036C15.005 32.036 18.0895 28.8931 21.174 28.8931C24.2585 28.8931 27.454 32.036 29.5473 32.036C31.6406 32.036 34.2837 28.8931 37.5902 28.8931C40.8966 28.8931 43.2623 32.036 45.686 32.036C47.0051 32.036 48.1929 31.2131 49.0025 30.4645V27.3217C48.1929 28.0702 47.0051 28.8931 45.686 28.8931C43.2623 28.8931 40.8941 25.7503 37.5902 25.7503C34.2863 25.7503 31.6406 28.8931 29.5473 28.8931C27.454 28.8931 24.2585 25.7503 21.174 25.7503C18.0895 25.7503 15.005 28.8931 13.1311 28.8931C11.2573 28.8931 9 27.3193 9 27.3193V30.4621V30.4645Z",
    fill: "#D69B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 38.2123C9 38.2123 11.2573 39.7837 13.1311 39.7837C15.005 39.7837 18.0895 36.6409 21.174 36.6409C24.2585 36.6409 27.454 39.7837 29.5473 39.7837C31.6406 39.7837 34.2837 36.6409 37.5902 36.6409C40.8966 36.6409 43.2623 39.7837 45.686 39.7837C47.0051 39.7837 48.1929 38.9608 49.0025 38.2123V35.0695C48.1929 35.818 47.0051 36.6409 45.686 36.6409C43.2623 36.6409 40.8941 33.498 37.5902 33.498C34.2863 33.498 31.6406 36.6409 29.5473 36.6409C27.454 36.6409 24.2585 33.498 21.174 33.498C18.0895 33.498 15.005 36.6409 13.1311 36.6409C11.2573 36.6409 9 35.0695 9 35.0695V38.2123Z",
    fill: "#D69B29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 22,
    fill: "white",
    transform: "translate(9 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp2);
export default __webpack_public_path__ + "static/media/temp_2.69435dbee989d234e5440731f08ee212.svg";
export { ForwardRef as ReactComponent };